export default __webpack_public_path__ + "static/media/about-sec-img.bd7f5f8e.jpg";